var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MnemonicImage',{staticClass:"GameChoiceItem --global-clickable",class:[("state-" + _vm.state)],attrs:{"image":_vm.image},nativeOn:{"click":function($event){return _vm.handleClick($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }